import React, { InputHTMLAttributes, ReactNode } from "react";
import classNames from "classnames";
import { FieldValues } from "react-hook-form";

import styles from "../input.module.scss";

export interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  registration?: FieldValues;
  placeholder?: string;
  error?: string | false;
  isRequired?: boolean;
  label?: string | ReactNode;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  icon?: ReactNode;
  isHorizontal?: boolean;
}
export const TextInput: React.FC<TextInputProps> = ({
  registration,
  placeholder = "placeholder",
  error,
  isRequired = false,
  label,
  value,
  disabled,
  onChange,
  className,
  type = "text",
  icon,
  isHorizontal = false,

  ...rest
}) => {
  const inputClass = classNames(
    styles.container,
    className,
    isHorizontal && styles.isHorizontal
  );
  const inputContainerClass = classNames(
    styles.input_container,
    disabled && styles.disabled
  );
  return (
    <div className={inputClass}>
      <div className={styles.label}>
        {isRequired && <span className="text-danger"> * </span>}
        {icon}
        {label && <span>{label}</span>}
      </div>
      <div className={inputContainerClass}>
        <input
          type={type}
          disabled={disabled}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          {...registration}
          {...rest}
        />
      </div>

      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};
